import React from 'react';
import Header from '../common/header';
import ItTraining from '../layout/servicedetails/IT Training/it training';
import Categories from '../layout/categories/categories';
import Footer from '../common/footer';




function ItTrainingmain() {
    return (
        <div>
            <Header />
            <ItTraining />
            <Categories />
            <Footer />
        </div>
    )
}

export default ItTrainingmain;